import React from 'react'
import { Checkbox, SvgIcon } from '@mui/material'
import { ReactComponent as CheckedIcon } from '../../../../assets/images/checkbox-checked.svg'
import { ReactComponent as UncheckedIcon } from '../../../../assets/images/checkbox-unchecked.svg'

export const DataTableCheckbox = ({
    checked,
    disabled = false,
    isSaving = false,
    label,
    onChange,
}: {
    checked: boolean
    disabled?: boolean
    /** A write is in flight for this row. */
    isSaving?: boolean
    label: string
    onChange: (checked: boolean) => void
}) => (
    <Checkbox
        size="small"
        checked={checked}
        disabled={disabled || isSaving}
        inputProps={{ 'aria-label': label }}
        onChange={(event) => onChange(event.target.checked)}
        // The tick stays put while the write is in flight, so unchecking shows progress rather than
        // an immediately empty box.
        icon={
            <SvgIcon
                component={isSaving ? CheckedIcon : UncheckedIcon}
                inheritViewBox
                sx={{ fontSize: '16px' }}
                color="inherit"
            />
        }
        checkedIcon={<SvgIcon component={CheckedIcon} inheritViewBox sx={{ fontSize: '16px' }} color="inherit" />}
        sx={{
            p: 0,
            color: 'figma.primary',
            '&.Mui-disabled': {
                // A ticked box stays blue when it merely cannot be changed: grey reads as "no
                // access" when the point is that access is granted.
                color: isSaving || !checked ? 'figma.grayscale.tier4' : 'figma.primary',
                // MUI drops pointer events on a disabled control, which takes the cursor with them.
                cursor: 'not-allowed',
                pointerEvents: 'auto',
            },
        }}
    />
)

export default DataTableCheckbox
